module.exports = __webpack_public_path__ + "img/tag_black_oval.4227959d.svg";